module.exports = __webpack_public_path__ + "static/phil-knight-88bbfcc85559ba8536c9f14c6d57fd0b.jpg";